import { action, payload } from 'ts-action';

import { SmartPhrase } from './types';

import { CoordinateModel } from '../../models/coordinate.model';
import { FactSheetModel } from '../../models/factSheet.model';
import {
    GetProductDetailsModel,
    GetProductListModel,
    GetProductModel,
    NeighborsProductsModel,
} from '../../models/products.model';
import { GetSujetCheckModel, RequestModel, SetSujetCheckModel, SujetCheckModel } from '../../models/request.model';

import { DataSchemeFilter, DataSchemeList, DataSchemeProduct, DataSchemeSingleProduct } from './';

export const LOCATION = '[LOCATION]';

export const GET_PRODUCT_LIST = `${LOCATION} GET_PRODUCT_LIST`;
export const SET_PRODUCT_LIST = `${LOCATION} SET_PRODUCT_LIST`;
export const SET_PRODUCT_LIST_WITH_RESET = `${LOCATION} SET_PRODUCT_LIST_WITH_RESET`;

export const GET_PRODUCT = `${LOCATION} GET_PRODUCT`;
export const GET_PRODUCT_DETAILS = `${LOCATION} GET_PRODUCT_DETAILS`;
export const SET_PRODUCT_DETAILS = `${LOCATION} SET_PRODUCT_DETAILS`;
export const SET_PRODUCTS = `${LOCATION} SET_PRODUCTS`;

export const SET_BOOKING_YEAR = `${LOCATION} SET_BOOKING_YEAR`;

export const GET_SMART_PHRASES = `${LOCATION} GET_SMART_PHRASES`;
export const SET_SMART_PHRASE = `${LOCATION} SET_SMART_PHRASE`;
export const SET_SMART_PHRASES = `${LOCATION} SET_SMART_PHRASES`;
export const SET_SMART_PHRASES_LIST = `${LOCATION} SET_SMART_PHRASES_LIST`;

export const GET_NEIGHBORS_PRODUCTS = `${LOCATION} GET_NEIGHBORS_PRODUCTS`;
export const SET_NEIGHBORS_PRODUCTS = `${LOCATION} SET_NEIGHBORS_PRODUCTS`;

export const UPDATE_COORDINATE_DATA = `${LOCATION} UPDATE_COORDINATE_DATA`;
export const SET_COORDINATE_DATA = `${LOCATION} SET_COORDINATE_DATA`;

export const RESET_DATA_FILTER = `${LOCATION} RESET_DATA_FILTER`;
export const UPDATE_DATA_FILTER = `${LOCATION} UPDATE_DATA_FILTER`;
export const SET_DATA_FILTER = `${LOCATION} SET_DATA_FILTER`;
export const GET_DATA_FILTER = `${LOCATION} GET_DATA_FILTER`;

export const GET_FACT_SHEET = `${LOCATION} GET_FACT_SHEET`;

export const SET_FACT_SHEET_PDF = `${LOCATION} SET_FACT_SHEET_PDF`;
export const SET_FACT_SHEET_XLSX = `${LOCATION} SET_FACT_SHEET_XLSX`;

export const SEND_REQUEST = `${LOCATION} SEND_REQUEST`;

export const GET_CURRENT_POSITION = `${LOCATION} GET_CURRENT_POSITION`;

export const GET_DATA_FROM_URL_PARAMS = `${LOCATION} GET_DATA_FROM_URL_PARAMS`;

export const ABORT_SEARCH = `${LOCATION} ABORT_SEARCH`;

export const CREATE_ABORT_CONTROLLER = `${LOCATION} CREATE_ABORT_CONTROLLER`;

export const UPLOAD_SUJETCHECK_IMAGE = `${LOCATION} UPLOAD_SUJETCHECK_IMAGE`;
export const SET_SUJETCHECK_IMAGE_DATA = `${LOCATION} SET_SUJETCHECK_IMAGE_DATA`;
export const GET_SUJETCHECK_IMAGES = `${LOCATION} GET_SUJETCHECK_IMAGES`;
export const SET_SUJETCHECK_IMAGES = `${LOCATION} SET_SUJETCHECK_IMAGES`;

export const getProductList = action(
    GET_PRODUCT_LIST,
    payload<{ bookingyear?: number; payload?: Partial<GetProductListModel>; reset?: boolean }>()
);

export const setProductList = action(SET_PRODUCT_LIST, payload<DataSchemeList>());

export const getProductDetails = action(GET_PRODUCT_DETAILS, payload<GetProductDetailsModel>());

export const setProductDetails = action(SET_PRODUCT_DETAILS, payload<DataSchemeSingleProduct>());

export const getProduct = action(GET_PRODUCT, payload<GetProductModel>());

export const setProducts = action(SET_PRODUCTS, payload<DataSchemeProduct>());

export const getNeighborsProducts = action(GET_NEIGHBORS_PRODUCTS, payload<Pick<GetProductModel, 'urn' | 'bookingyear'>>());

export const setNeighborsProducts = action(SET_NEIGHBORS_PRODUCTS, payload<NeighborsProductsModel[]>());

export const setProductListWithReset = action(SET_PRODUCT_LIST_WITH_RESET, payload<DataSchemeList>());

export const updateDataFilter = action(UPDATE_DATA_FILTER, payload<DataSchemeFilter>());

export const setDataFilter = action(SET_DATA_FILTER, payload<DataSchemeFilter>());

export const updateCoordinateData = action(UPDATE_COORDINATE_DATA, payload<Partial<CoordinateModel> | null>());

export const setCoordinateData = action(SET_COORDINATE_DATA, payload<CoordinateModel>());

export const getDataFilter = action(
    GET_DATA_FILTER,
    payload<{ bookingyear?: number; coordinate?: CoordinateModel; search?: string }>()
);

export const resetDataFilter = action(RESET_DATA_FILTER);

export const getDataFromUrlParams = action(GET_DATA_FROM_URL_PARAMS);

export const getFactSheet = action(GET_FACT_SHEET, payload<FactSheetModel>());

export const setFactSheetPDF = action(SET_FACT_SHEET_PDF, payload<string>());

export const setFactSheetXLSX = action(SET_FACT_SHEET_XLSX, payload<string>());

export const sendRequest = action(SEND_REQUEST, payload<RequestModel>());

export const getCurrentPosition = action(GET_CURRENT_POSITION);

export const setBookingYear = action(SET_BOOKING_YEAR, payload<number>());

export const getSmartPhrases = action(GET_SMART_PHRASES);

export const setSmartPhrases = action(SET_SMART_PHRASES, payload<SmartPhrase[]>());

export const setSmartPhrase = action(SET_SMART_PHRASE, payload<SmartPhrase>());

export const setSmartPhrasesList = action(SET_SMART_PHRASES_LIST, payload<string[]>());

export const abortSearch = action(ABORT_SEARCH);

export const createNewAbortController = action(CREATE_ABORT_CONTROLLER);
export const getSujetcheckImages = action(GET_SUJETCHECK_IMAGES, payload<GetSujetCheckModel>());
export const setSujetcheckImages = action(SET_SUJETCHECK_IMAGES, payload<SetSujetCheckModel>());
export const uploadSujetcheckImage = action(UPLOAD_SUJETCHECK_IMAGE, payload<FormData>());
export const setSujetcheckImageData = action(SET_SUJETCHECK_IMAGE_DATA, payload<SujetCheckModel>());
